import { computed, watch } from 'vue';
import { GlobalStore } from '@/store/global';
import { ISectionContent } from '@/presentation/components/section-content/ISectionContent';

export class CountryCB {
	public time: ISectionContent[] = [];
	public fees: ISectionContent[] = [];
	public more: ISectionContent[] = [];

	public visa = computed(() => {
		return GlobalStore.getters.getVisa();
	});

	public destinationCountryName = computed(() => {
		return GlobalStore.getters.getDestinationCountry()?.name;
	});

	public originCountryName = computed(() => {
		return GlobalStore.getters.getOriginCountry()?.name;
	});

	public constructor() {
		this.updateSections();
		watch(this.visa, () => this.updateSections());
	}

	private updateSections(): void {
		this.time = [];
		this.fees = [];
		this.more = [];

		if (this.visa.value) {
			if (this.visa.value.applicationDescription) {
				this.time.push({
					title: 'Application description',
					subtitle: null,
					description: this.visa.value.applicationLink
						? `${this.visa.value.applicationDescription}
					<br><a href="${this.visa.value.applicationLink}">Application link</a>`
						: this.visa.value.applicationDescription,
				});
			}

			this.time.push(
				{
					title: 'Blocked bank account',
					subtitle: this.visa.value.requiresBlockedBankAccount ? 'required' : 'not required',
					description: this.visa.value.requiresBlockedBankAccount
						? 'A blocked bank account is required.'
						: 'No blocked bank account is required.',
				},
				{
					title: 'Visa interview',
					subtitle: this.visa.value.requiresInterview
						? 'required'
						: this.visa.value.mayRequireInterview
							? 'may be required'
							: 'not required',
					description: this.visa.value.requiresInterview
						? 'An interview is required  during the application process.'
						: this.visa.value.mayRequireInterview
							? 'An interview is required  during the application process.'
							: 'No interview is required.',
				},
				{
					title: 'Travel abroad',
					subtitle: this.visa.value.requiresTravelAbroad ? 'required' : 'not required',
					description: this.visa.value.requiresTravelAbroad
						? this.visa.value.travelAbroadDescription ?? 'Travel abroad is required'
						: 'No travel abroad is required',
				}
			);

			if (this.visa.value.visaDuration) {
				this.time.push({
					title: 'Visa duration',
					subtitle: this.visa.value.visaDuration,
					description: null,
				});
			}

			if (this.visa.value.otherInformation) {
				this.time.push({
					title: 'Other information',
					subtitle: null,
					description: this.visa.value.otherInformation,
				});
			}

			if (this.visa.value.visaFeeAmount && this.visa.value.visaFeeCurrencyIso) {
				this.fees.push({
					title: 'Visa fee',
					subtitle: `${this.visa.value.visaFeeAmount} ${this.visa.value.visaFeeCurrencyIso}`,
					description: `The standard price for the 
						${this.visa.value.name} is ${this.visa.value.visaFeeAmount} ${this.visa.value.visaFeeCurrencyIso}`,
				});
			}

			this.fees.push(
				{
					title: 'Proof of minimum funds',
					subtitle: this.visa.value.requiresProofOfFunds ? 'required' : 'not required',
					description: this.visa.value.proofOfFundsDescription,
				},
				{
					title: 'Other expenses',
					subtitle: this.visa.value.otherExpenses ? 'required' : 'none required',
					description: this.visa.value.otherExpenses,
				},
				{
					title: 'Health insurance',
					subtitle: this.visa.value.requiresHealthInsurance ? 'required' : 'not required',
					description: this.visa.value.healthInsuranceDescription,
				}
			);

			this.more = [
				{
					title: 'Proof of language skills',
					subtitle: this.visa.value.requiresProofOfLanguage ? 'required' : 'not required',
					description: this.visa.value.requiresProofOfLanguage
						? `As a resident of ${this.visa.value.originCountry.name ?? ''} you need to prove your language skills.`
						: `No need to prove your language skills for residents of ${this.visa.value.originCountry.name ?? ''}.`,
				},
				{
					title: 'Medical check',
					subtitle: this.visa.value.requiresMedicalExam ? 'required' : 'none required',
					description: this.visa.value.requiresMedicalExam
						? 'Medical exam is not required'
						: `No medical check is required for residents of ${this.visa.value.originCountry.name ?? ''}.`,
				},
				{
					title: 'Biometrics',
					subtitle: this.visa.value.requiresBiometrics ? 'required' : 'none required',
					description: this.visa.value.requiresBiometrics ? 'Biometrics are required' : 'No biometrics are required',
				},
				{
					title: 'Criminal records',
					subtitle: this.visa.value.requiresCriminalRecordsCheck ? 'required' : 'none required',
					description: this.visa.value.requiresCriminalRecordsCheck
						? 'Criminal records are required'
						: 'No criminal records are required',
				},
				{
					title: 'Proof of accommodation',
					subtitle: this.visa.value.requiresProofOfAccommodation ? 'required' : 'not required',
					description: this.visa.value.requiresProofOfAccommodation
						? 'Proof of accommodation required'
						: 'Proof of accommodation not required',
				},
			];
		}
	}

	public openLocalizationSettings(): void {
		GlobalStore.actions.openLocalizationSettings();
	}
}
